import { apiCall } from "../utility/apiCall";

export const login = async payload => {
  return await apiCall("api/login", "POST", payload);
  //return await loginFetch("/users/getUserDetails", "POST", payload);
};

export const signup = async payload => {
  return await apiCall("api/signup", "POST", payload);
};

export const forgotPassword = async payload => {
  return await apiCall("api/signup/forgotPassword", "POST", payload);
};

export const resendActivation = async payload => {
  return await apiCall("api/signup/resendActivationLink", "POST", payload);
};
export const resetPassword = async payload => {
  return await apiCall("api/signup/resetPassword", "POST", payload);
};

export const logout = async () => {
    return await apiCall("api/logout", "GET");
};

export const getCountryList = async () => {
  return await apiCall("api/countries", "GET");
};



// WEBPACK FOOTER //
// ./src/services/login.js